import { getCurrentDevice, type DeviceName } from './device';

export function lockBodyScroll(deviceName?: DeviceName) {
  if (!document.body) {
    return;
  }

  document.body.style.overscrollBehavior = 'contain';
  if (deviceName && getCurrentDevice() === deviceName) {
    document.body.style.overflow = 'hidden';
    return;
  }
  document.body.style.overflow = 'hidden';
}

export function unlockBodyScroll(deviceName?: DeviceName) {
  if (!document.body) {
    return;
  }

  document.body.style.overscrollBehavior = '';
  if (deviceName && getCurrentDevice() === deviceName) {
    document.body.style.overflow = '';
    return;
  }
  document.body.style.overflow = '';
}
